import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { UserAccessRightsGuard } from '../../role/user-role/user-access-rights.guard'
import { AccessRights } from '../../role/user-role/user-role'
import { RouterHistoryLevelGuard } from 'src/app/shared/guards/router-history-level.guard'
import { RolePermissionsGeneralTabComponent } from '../general-tab/show.component'

const routes: Routes = [
  {
    path: ':rolePermissionsId/modal-role',
    component: RolePermissionsGeneralTabComponent,
    outlet: 'modal',
    canActivate: [UserAccessRightsGuard, RouterHistoryLevelGuard],
    data: { accessRights: [AccessRights.RolePermissions_read] }
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ShowModalRoutingModule {}
